// extracted by mini-css-extract-plugin
export default {"fileFormatTextIncorrect":"gtwFileUpload_fileFormatTextIncorrect__X0deQ","main":"gtwFileUpload_main__qXN4k"};